import { fetchModelClassesAndProperties } from 'src/actions/projects/utils/fetchModelClassesAndProperties';
import { PendingModelData } from 'src/store/state/projects';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const requestModelDataForProject =
  ({
    projectId,
    databaseId,
    modelNames,
  }: {
    projectId: string;
    databaseId: string;
    modelNames: string[];
  }) =>
  async (
    _dispatch: AppDispatch,
    getState: ReduxStateGetter
  ): Promise<Record<string, PendingModelData>> => {
    const { databases } = getState();
    const { namedGraphsByModel = {} } =
      databases.databasesById?.[databaseId] || {};

    const results: Record<string, PendingModelData> = {};

    await Promise.all(
      modelNames.map(async (modelName) => {
        const namedGraphs = namedGraphsByModel[modelName];
        if (namedGraphs) {
          const { classes, properties } = await fetchModelClassesAndProperties({
            projectId,
            modelName,
            databaseId,
            namedGraphs,
          });

          results[modelName] = {
            modelName,
            classes,
            properties,
          };
        }
      })
    );

    return results;
  };
